import React, { Component } from 'react';
import BootstrapColumn from '../../../hoc/BootstrapColumn';
import FormInputFields from '../../../Components/FormInputFields';
import Wrp from '../../../hoc/Wrp/Wrp';
class ShowEntries extends Component {
    
  perPageOnChangeHandler= (value) =>{
      const pagination = {
        ...this.props,
        page:0,
        perPage:value
      }
      this.props.recordsChangeHandler(pagination,true);
  }
    render () {
        const item = 
        {
          type:'PickList',
          isDefault:true,
          label:{
            text:"showEntries",
            className:"form-control form-control-sm",
          },
          isMandatory:false,
          key:'showEntries',
          value:this.props.perPage,
          options:[
            {id:10,value:10},
            {id:25,value:25},
            {id:50,value:50},
            {id:100,value:100},
          ],
          attributes:{
          },
          changeHandler:this.perPageOnChangeHandler
        }
       
          const hocWrp = {Wrap: (this.props.isBottom)? Wrp:BootstrapColumn};
          const appendClass = (this.props.isBottom)? 'p-2':'';
        return (
                 
                    <div className={"dataTables_length"}>
                      {(this.props.isBottom===true)?
                        <Wrp>
                         Showing &nbsp;
                          <FormInputFields {...item}/> of <span className="badge badge-info ml-1">
                          {this.props.totalRecords} </span>
                          &nbsp;
                            Records
                         
                        </Wrp>
                      :''}
                        
                    </div>
                 
        )
    }
}

export default ShowEntries;